
import AlertDialogOnClose from "../../../../components/admin/AlertDiologOnClose";
import ListaArComprimido from "./ListaLinhasProducao";
export default function LinhaProducaoForm() {
    return(
        <AlertDialogOnClose nome={"Linha Produção"} placeholder={"Insira o nome do equipamento"}>
        	<ListaArComprimido />
        </AlertDialogOnClose>
    )
} 